import Cookies from 'js-cookie';
import $ from 'jquery';

export function setUTMCookie() {
  let domain = window.location.host.split('.').reverse();
  domain = '.' + domain[1] + '.' + domain[0];

  // Read the UTM-params
  let utm_query = decodeURIComponent(window.location.search.substring(1));
  let utm_variables = utm_query.split('&');
  let utms = {};

  utm_variables.forEach(function (variable) {
    let name = variable.split('=')[0];
    let value = variable.split('=')[1];

    // Set up the cookie and utm json object
    if (name.slice(0, 4) === 'utm_') {
      if (
        name !== 'utm_original_source' &&
        name !== 'utm_original_campaign' &&
        name !== 'utm_original_medium' &&
        name !== 'utm_original_url' &&
        name !== 'utm_source' &&
        name !== 'utm_campaign' &&
        name !== 'utm_campaign_name' &&
        name !== 'utm_medium' &&
        name !== 'utm_url'
      ) {
        Cookies.set('px_' + name, value, { domain: domain, expires: 365 });
      }

      utms[name] = value;
    }
  });

  // Set UTM cookies for MailChimp
  function setMailChimpCookies(type) {
    let referrer = (document.referrer) ? document.referrer : 'direct_visit';

    let source = '';
    if (utms.utm_original_source) source = utms.utm_original_source;
    else if (utms.utm_source) source = utms.utm_source;
    else source = referrer;

    let campaign = '';
    if (utms.utm_original_campaign) campaign = utms.utm_original_campaign;
    else if (utms.utm_campaign) campaign = utms.utm_campaign;
    else campaign = 'not_set';

    let campaign_name = '';
    if (utms.utm_campaign_name) campaign_name = utms.utm_campaign_name;
    else campaign_name = 'not_set';

    let medium = '';
    if (utms.utm_original_medium) medium = utms.utm_original_medium;
    else if (utms.utm_medium) medium = utms.utm_medium;
    else medium = 'not_set';

    let url = '';
    if (utms.utm_original_url) url = utms.utm_original_url;
    else if (utms.utm_url) url = utms.utm_url;
    else url = 'not_set';

    Cookies.set(
      'px_utm_' + type + '_source',
      source,
      { domain: domain, expires: 365 }
    );

    Cookies.set(
      'px_utm_' + type + '_campaign',
      campaign,
      { domain: domain, expires: 365 }
    );

    Cookies.set(
      'px_utm_' + type + '_campaign_name',
      campaign_name,
      { domain: domain, expires: 365 }
    );

    Cookies.set(
      'px_utm_' + type + '_medium',
      medium,
      { domain: domain, expires: 365 }
    );

    Cookies.set(
      'px_utm_' + type + '_url',
      url,
      { domain: domain, expires: 365 }
    );
  }

  if (!Cookies.get('px_utm_original_source')) {
    // 1. If user visits website at the very first time
    setMailChimpCookies('original');
  } else {
    // 2. If user visits website second and subsequent times
    setMailChimpCookies('current');
  }

  // Filling MailChimp UTM hidden fields
  if ($('#mc-embedded-subscribe-form').length > 0) {
    let $source_original = $('#mce-UTM_SRCE_O');
    let $campaign_original = $('#mce-UTM_CMPN_O');
    let $medium_original = $('#mce-UTM_MEDM_O');
    let $url_original = $('#mce-UTM_URL_O');
    let $source_current = $('#mce-UTM_SRCE_C');
    let $campaign_current = $('#mce-UTM_CMPN_C');
    let $medium_current = $('#mce-UTM_MEDM_C');
    let $url_current = $('#mce-UTM_URL_C');

    let $lead_id = $('#mce-LEADID');

    let $submit = $('#mc-embedded-subscribe');

    setTimeout(() => {
      $source_original.val(Cookies.get('px_utm_original_source'));
      $campaign_original.val(Cookies.get('px_utm_original_campaign'));
      $medium_original.val(Cookies.get('px_utm_original_medium'));
      $url_original.val(Cookies.get('px_utm_original_url'));

      $source_current.val(Cookies.get('px_utm_current_source'));
      $campaign_current.val(Cookies.get('px_utm_current_campaign'));
      $medium_current.val(Cookies.get('px_utm_current_medium'));
      $url_current.val(Cookies.get('px_utm_current_url'));
    }, 2000);

    $submit.on('click', function() {
      let leadId = Date.now();

      $lead_id.val(leadId);

      Cookies.set(
        'px_utm_original_lead_id',
        leadId,
        { domain: domain, expires: 365 }
      );
    });
  }
}

